import { makeStyles } from '@material-ui/core'
import React from 'react'
import { Checkbox } from 'web/src/app/root/components/common'

export const NotificationItem = ({ label, checked, onClick }) => {
    const classes = useStyles()

    return (
        <div className={classes.detailsRow}>
            <Checkbox label={label} onClick={onClick} checked={checked} />
        </div>
    )
}

const useStyles = makeStyles(() => ({
    detailsRow: {
        display: 'flex',
        marginBottom: 10,
        alignItems: 'center'
    }
}))
